export default "__VITE_ASSET__C0FVfv2W__"